import { useTheme } from '@mui/material/styles';

function sparklePath(cx, cy, size) {
  const s = size / 2;
  const d = size * 0.22;
  return `M${cx} ${cy - s} L${cx + d} ${cy - d} L${cx + s} ${cy} L${cx + d} ${cy + d} L${cx} ${cy + s} L${cx - d} ${cy + d} L${cx - s} ${cy} L${cx - d} ${cy - d} Z`;
}

export default function LogoMain() {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const textColor = isDark ? '#ffffff' : '#0f172a';

  return (
    <svg width="168" height="36" viewBox="0 0 168 36" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Customer Lab">
      <defs>
        <linearGradient id="cl-logo-main-grad" x1="6" y1="4" x2="30" y2="32" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7c3aed" />
          <stop offset="1" stopColor="#0891b2" />
        </linearGradient>
      </defs>
      <circle cx="18" cy="18" r="18" fill="url(#cl-logo-main-grad)" />
      <path d={sparklePath(12, 17, 11)} fill="#fff" />
      <path d={sparklePath(22.5, 11.5, 6.5)} fill="#fff" />
      <path d={sparklePath(23.5, 23, 5.5)} fill="#fff" />
      <text
        x="44"
        y="24"
        fontFamily="'Public Sans', 'Inter', sans-serif"
        fontSize="15"
        fontWeight="700"
        letterSpacing="-0.3"
        fill={textColor}
      >
        Customer Lab
      </text>
    </svg>
  );
}
